import React, {useState, useEffect} from 'react';
import DataGrid, {
  Column,
  Export,
  Pager,
  Paging,
  FilterRow,
  HeaderFilter,
} from 'devextreme-react/data-grid';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import logsApi from '../../api/logs/logsApi';

export default function Log() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const data = await logsApi.getLogsAsync();
        setLogs(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchLogs();
  }, []);

  const onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Logs');
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      customizeCell: (options) => {
        const excelCell = options;
        excelCell.font = { name: 'Arial', size: 12 };
        excelCell.alignment = { horizontal: 'left' };
      },
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Logs.xlsx');
      });
    });
    e.cancel = true;
  };

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Logs</h2>

      <DataGrid
        className={'dx-card wide-card'}
        dataSource={logs}
        showBorders={false}
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        keyExpr="id"
        onExporting={onExporting}
      >
        <Paging defaultPageSize={10} />
        <Pager showPageSizeSelector={true} showInfo={true} />
        <FilterRow visible={true} />
        <Export enabled={true} />
        <HeaderFilter visible={true} />

        <Column dataField={'id'} caption={'Log ID'} width={90} hidingPriority={2} />
        <Column dataField={'appName'} caption={'App Name'} />
        <Column dataField={'userName'} caption={'User Name'} />
        <Column dataField={'correlationId'} caption={'Correlation Id'} />
        <Column dataField={'activityType'} caption={'Activity Type'} />
        <Column dataField={'dateTime'} caption={'Date'} dataType={'datetime'} defaultSortOrder={'desc'} />
        <Column dataField={'event'} caption={'Event'} />
        <Column dataField={'url'} caption={'URL'} />
        <Column dataField={'body'} caption={'Body'} />
        <Column dataField={'response'} caption={'Response'} />
      </DataGrid>
    </React.Fragment>
  );
}